import Typography from 'antd/lib/typography';
import * as React from 'react';

type AcceptedFileTypeMessageProps = {
    acceptedFileTypes: string[];
    showFileTypes?: boolean;
};

export function UploadFooterText({ acceptedFileTypes, showFileTypes }: AcceptedFileTypeMessageProps) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {showFileTypes && (
                <Typography.Text type="secondary">Accepted file types: {acceptedFileTypes.join(', ')}</Typography.Text>
            )}
            <Typography.Text type="secondary">
                We take security seriously.{' '}
                <Typography.Link href="https://www.runway.team/security" target="_blank">
                    Read more
                </Typography.Link>{' '}
                about how we store sensitive information.
            </Typography.Text>
        </div>
    );
}
